import { usePathname } from "next/navigation";
import Link from "next/link";
import IconComponent from '@/helpers/functions/getIcon';

export default function NavigationItem({  anchor, url, icon, handleLinkClick }) {
  const pathname = usePathname();
  const isActive = pathname == url;

  return (
    <li className={`group relative lg:bg-white/0  hover:bg-dark lg:hover:bg-card duration-200 rounded-md ${isActive ? 'bg-card lg:!bg-card-foreground hover:bg-card ' : 'bg-dark' }`} >
      <Link className="flex gap-2 h-full  relative w-full px-4 py-3  items-center  text-white/80 font-medium text-sm " onClick={handleLinkClick}  href={url}  data-active={isActive}>
        {icon && <IconComponent
            iconName={icon}
            className={`!text-[17px] text-white/80 group-hover:text-blue group-hover:rotate-12 duration-200 ${isActive ? '!text-blue' : '' }`}
          />}
        <span className={`group-hover:text-white  duration-200 ${isActive ? 'text-white font-semibold' : '' }`}>{anchor}</span>
      </Link>
    </li>
  );
}
